import { SimulationType } from "./types";

export type PdfDownloadActionKey = "simulation" | "presentation";

interface PdfDownloadAction {
  key: PdfDownloadActionKey;
  label: string;
  tooltip: string;
}

// As comparações espelhadas de bateria (MLBESS/APEBESS) não geram PDF.
const simulationTooltips: Record<
  Exclude<SimulationType, "MLBESS" | "APEBESS">,
  string
> = {
  ML:
    "Baixa o relatório da simulação comparando mercado cativo e mercado livre.",
  MLXAPE:
    "Baixa o relatório da simulação comparando mercado livre e autoprodução.",
  GDXAPE:
    "Baixa o relatório da simulação comparando geração distribuída e autoprodução.",
  APE:
    "Baixa o relatório da simulação comparando mercado cativo e autoprodução.",
};

export function getPdfDownloadActions(
  simulationType: SimulationType,
  fortlev?: boolean
): PdfDownloadAction[] {
  if (simulationType === "MLBESS" || simulationType === "APEBESS") {
    return [];
  }

  const actions: PdfDownloadAction[] = [
    {
      key: "simulation",
      label: "GERAR SIMULAÇÃO EM PDF",
      tooltip: simulationTooltips[simulationType],
    },
  ];

  if (simulationType === "ML" && !fortlev) {
    actions.push({
      key: "presentation",
      label: "GERAR APRESENTAÇÃO EM PDF",
      tooltip: "Baixa a apresentação comercial da simulação de mercado livre.",
    });
  }

  return actions;
}
